





















































































































































































































































import { UwField, UwInput } from '@ultraware/vee-form-handler'
import { QBtn, QField, QInput, QOptionGroup, QRadio, QSelect } from 'quasar'
import FormattedPriceInput from 'src/components/FormattedPriceInput.vue'
import LicenseTypePicker from 'src/components/LicenseTypePicker.vue'
import currencies from 'src/domains/static/currencies.json'
import intendedEndUserRoles from 'src/domains/static/intendedEndUserRoles.json'
import productStates from 'src/domains/static/productStates.json'
import sectors from 'src/domains/static/sectors.json'
import mediums from 'src/domains/static/mediums.json'
import { EDurationType, EProductState, IArticle, readArticle, readCourses, readLevels } from 'src/store/article'

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { IVxsPromise, vxsActionFetch, vxsDataGetter } from 'vuex-xhr-state'
import { IQSelectOptions } from '@ultraware/vue-helpers/dist/types/quasar-types'
import DateInput from './DateInput.vue'
import { commonDateFormat, isoDateFormat, transformDates, userDateFormat } from '@/domains/date'

@Component({
  components: {
    QBtn,
    QField,
    QInput,
    QOptionGroup,
    QRadio,
    QSelect,
    FormattedPriceInput,
    LicenseTypePicker,
    UwInput,
    UwField,
    ValidationProvider,
    ValidationObserver,
    DateInput,
  },
  filters: {
    chipsMessage(attr: string): string {
      return 'Druk na het invoeren op enter om een ' + attr + ' toe te voegen.'
    },
  },
})

export default class ArticleForm extends Vue {
  @Prop({ type: Object, required: true }) public value!: IArticle
  @Prop({ type: Function, default: (): boolean => true }) public onBeforeSubmit!: () => void
  @Prop({ type: Boolean, default: false }) public editModus!: boolean
  @Prop({ type: Object, required: true }) public validationErrors!: Record<string, string[]>
  @vxsDataGetter(readArticle) private readArticleByEAN!: (_: string) => IArticle
  @vxsActionFetch(readArticle) private fetchArticleByEAN!: (_: string) => IVxsPromise<IArticle>
  @vxsDataGetter(readCourses) private readCourses!: () => IQSelectOptions[]
  @vxsActionFetch(readCourses) private fetchCourses!: () => IVxsPromise<IQSelectOptions[]>
  @vxsDataGetter(readLevels) private readLevels!: () => IQSelectOptions[]
  @vxsActionFetch(readLevels) private fetchLevels!: () => IVxsPromise<IQSelectOptions[]>
  public $refs!: {
    validationObserver: InstanceType<typeof ValidationObserver>
  }

  public editArticle: IArticle | null = null
  public endOfLifeDate: string | null = null

  get listOptions(): object {
    return {
      courses: this.courses,
      currencies,
      intendedEndUserRoles,
      levels: this.levels,
      productStates,
      sectors,
      mediums,
    }
  }

  public VATCategory = ''
  public priceInCents: number | null = null

  public created(): void {
    this.fetchCourses()
    this.fetchLevels()
  }

  get courses(): IQSelectOptions[] {
    return this.readCourses()
  }

  get levels(): IQSelectOptions[] {
    return this.readLevels()
  }

  get authorHelper(): string {
    return this.$options.filters!.chipsMessage('auteur')
  }

  get isMediumTypeBook(): boolean {
    return this.editArticle!.Medium === 'Boek'
  }

  get isDurationTypeSchoolYear(): boolean {
    return this.editArticle!.DurationType === EDurationType.school_year
  }

  @Watch('value', { deep: true, immediate: true })
  public valueHandler(val: IArticle, oldVal: IArticle): void {
    if (val === oldVal) return
    this.editArticle = this.copyArticle(val)
  }

  @Watch('validationErrors')
  public validationErrorsHandler(validationErrors: Record<string, string[]>): void {
    this.$refs.validationObserver.setErrors(validationErrors)
  }

  public checkArticleExists(EAN: string): void {
    if (this.editModus || EAN === '') return
    this.fetchArticleByEAN(EAN).then(() => {
      const editArticle = this.readArticleByEAN(EAN)
      if (editArticle !== undefined) {
        this.$q.dialog({
          title: 'Het artikel dat u probeert aan te maken bestaat al',
          message: 'Wilt u ' + editArticle.Title + ' (' + EAN + ') aanpassen?',
          ok: 'Ja',
          cancel: 'Nee',
        }).onOk((): void => {
          this.$router.push({
            name: 'editArticle',
            params: {
              EAN,
              userRedirected: 'true',
            },
          })
        }).onCancel((): void => {
          this.editArticle!.ProductId = ''
          this.updateAccessLocation()
        })
      }
    })
  }

  public copyArticle(val: IArticle): IArticle {
    const clonedArticle = JSON.parse(JSON.stringify(val))
    if ('PriceVATHigh' in clonedArticle && clonedArticle.PriceVATHigh !== null) {
      this.priceInCents = clonedArticle.PriceVATHigh
      this.VATCategory = 'High'
      delete clonedArticle.PriceVATHigh
    } else if ('PriceVATLow' in clonedArticle && clonedArticle.PriceVATLow !== null) {
      this.priceInCents = clonedArticle.PriceVATLow
      this.VATCategory = 'Low'
      delete clonedArticle.PriceVATLow
    } else {
      this.priceInCents = null
      this.VATCategory = ''
    }

    if (clonedArticle.DurationType === EDurationType.school_year || !clonedArticle.DurationDays) {
      clonedArticle.DurationDays = 364
    }

    if (clonedArticle.EndOfLifeDate) {
      this.endOfLifeDate = transformDates(clonedArticle.EndOfLifeDate, isoDateFormat, userDateFormat)
    }

    return clonedArticle
  }

  public submit(): void {
    Promise.resolve(this.onBeforeSubmit())
      .then(() => {
        this.formatFieldsForSubmit()
        try {
          if (document.activeElement !== null) (document.activeElement as HTMLElement).blur()
        } catch (e) {
          // catch because blur fails in test
        }

        this.$emit('submit', this.clearDigitalOnBookMedium())

        // reset validator
        requestAnimationFrame(() => {
          this.$refs.validationObserver.reset()
        })
      })
      .catch(() => { })
    document.documentElement.scrollTop = 0
  }

  private clearDigitalOnBookMedium(): IArticle {
    if (this.editArticle!.Medium !== 'Boek') return this.editArticle!

    const clonedArticle = JSON.parse(JSON.stringify(this.editArticle))

    clonedArticle.RedirectURL = undefined
    clonedArticle.AccessLocation = undefined
    clonedArticle.DurationDays = undefined
    clonedArticle.ZeroEnabled = false
    clonedArticle.ServiceCreditAllowed = false
    clonedArticle.ActivationCodeEnabled = false

    return clonedArticle
  }

  public formatFieldsForSubmit(): void {
    if (this.VATCategory === 'High') {
      this.editArticle!.PriceVATHigh = this.priceInCents!
      delete this.editArticle!.PriceVATLow
    } else if (this.VATCategory === 'Low') {
      this.editArticle!.PriceVATLow = this.priceInCents!
      delete this.editArticle!.PriceVATHigh
    }

    this.editArticle!.EndOfLifeDate =
      this.endOfLifeDate ? transformDates(this.endOfLifeDate, userDateFormat, commonDateFormat) : undefined
  }

  public updateAccessLocation(): void {
    if (this.editModus) return

    const baseUrl = process.env.VUE_APP_ACCESS_LOCATION
    this.editArticle!.AccessLocation = baseUrl!
      .concat('/', this.editArticle!.ProductId ? this.editArticle!.ProductId : 'EAN')
  }

  public endOfLifeRequired(): boolean {
    if (!this.editArticle) return false
    const prodState = this.editArticle.ProductState
    return prodState === EProductState.not_available ||
            prodState === EProductState.wont_appear
  }
}
